module.exports = __webpack_public_path__ + "static/img/1.47371e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/eng/1.png
// module id = yshL
// module chunks = 0